import { Capacitor } from '@capacitor/core'

export const AppConfig = {
  isNativePlatform: Capacitor.isNativePlatform(),
}
